import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import { NOTIFICATIONS } from "~/constans/notifications";
import { useUploads } from "~/entity/Uploads";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { defaultErrorHandlerFunc } from "~/shared/hooks/useRequestHandler";

export const useSetUploads = () => {
  const { t } = useTranslation();

  const [addNotificationMutation] = useAddNotificationMutation({});

  const { uploadDealerMetricFile, acceptFile, rejectFile } = useUploads();

  const useFileMutation = <TVariables, TData>(
    fn: (variables: TVariables) => Promise<TData>,
    successType: string,
    successTextKey: string,
    successDefault: string,
  ) =>
    useMutation(fn, {
      onSuccess: () => {
        addNotificationMutation({
          variables: {
            type: successType,
            content: t(successTextKey, {
              defaultValue: successDefault,
            }),
          },
        });
      },
      onError: (e) => {
        defaultErrorHandlerFunc({
          e,
          t,
          addNotificationMutation,
        });
      },
    });

  const uploadDealerMetricFileMutation = useFileMutation(
    uploadDealerMetricFile,
    NOTIFICATIONS.success,
    "indicators.notification.checkSuccess",
    "Файл успешно загружен",
  );
  const acceptFileMutation = useFileMutation(
    acceptFile,
    NOTIFICATIONS.success,
    "indicators.notification.checkSuccess",
    "Файл успешно загружен",
  );
  const rejectFileMutation = useFileMutation(
    rejectFile,
    NOTIFICATIONS.error,
    "indicators.notification.removeSuccess",
    "Отмена загрузки",
  );

  return {
    uploadDealerMetricFile: uploadDealerMetricFileMutation,
    acceptFile: acceptFileMutation,
    rejectFile: rejectFileMutation,
  };
};
